<template>
  <div>
    <div>
      <div v-if="testArrayContainsResults()" style="text-align:center;">
        <p
          style="vertical-align:middle; z-index:99; margin:auto 0px; color:grey; font-size:18px;margin-bottom:30px;"
        >
          {{ $i18n.t('admin.nodataToshow') }}
        </p>
      </div>
      <VueApexCharts
        ref="barchart"
        type="bar"
        :height="300 + this.heightOfTitle"
        :options="chartOptions"
        :series="series"
      />
      <div v-if="donnees.element_type === 'notation'" align="center">
        <star-rating
          style="display:inline-block; font-size:12px;"
          inactive-color="#4c514c"
          v-bind:star-size="18"
          :rating="calculMoyenne(donnees.donneesPourcentage)"
          :rounded-corners="false"
          :show-rating="true"
          :read-only="true"
          :round-start-rating="false"
          :fixed-points="2"
        ></star-rating>
      </div>
      <div style="margin-top:-10px; text-align:center; ">
        <button
          class="button is-primary"
          @click="showModalAutre()"
          v-if="donnees.autre === 1"
        >
          {{ $t('question.autre.details') }}
        </button>
      </div>
      <b-modal :width="620" :active.sync="showAutres">
        <PopupAutresResultats
          :questionId="questionId"
          :titre="donnees.intitule"
        />
      </b-modal>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import StarRating from 'vue-star-rating'
import PopupAutresResultats from '@/components/resultats/PopupAutresResultats'
import { mapGetters } from 'vuex'

export default {
  name: 'BarChart',
  props: ['donnees', 'questionId', 'window'],
  components: {
    VueApexCharts,
    StarRating,
    PopupAutresResultats
  },
  data () {
    return {
      translationEntitledAnswer: null,
      arrayPercentsStars: [],
      substringValue: 50,
      showAutres: false,
      widthInit: 0,
      chartOptions: {
        grid: {
          xaxis: {
            lines: {
              show: false
            }
          },
          yaxis: {
            lines: {
              show: false
            }
          },
          padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        },
        title: {
          align: 'left',
          style: {
            fontSize: '14px',
            fontWeight: 'bold',
            fontFamily: undefined,
            color: 'black'
          }
        },
        colors: ['#686b7e'],
        plotOptions: {
          bar: {
            barHeight: '90%',
            horizontal: true,
            dataLabels: {
              position: 'bottom'
            },
            colors: {
              // un jour ça serait bien de faire une boucle dessus et tester en fonction du nb de réponse
              backgroundBarColors: [
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8'
              ]
            }
          }
        },
        dataLabels: {
          textAnchor: 'start',
          style: {
            colors: ['white'],
            fontSize: 12,
            fontWeight: 500
          },
          formatter (val, opt) {
            let subStr = 450
            let svgWidth = 0
            var stringLabel = opt.w.globals.labels[opt.dataPointIndex]
            var svg = document.getElementsByTagName('svg')
            svgWidth = svg[0].getBoundingClientRect().width
            if (stringLabel.length > subStr) {
              return stringLabel.substring(0, subStr) + '...'
            } else if (stringLabel === '') return 'Autre'
            else return stringLabel
          }
        },
        xaxis: {
          categories: this.donnees.donneesPourcentage.noms,
          labels: {
            show: false,
            formatter (val) {
              return val + '%'
            }
          }
        },
        yaxis: {
          labels: {
            show: false
          },
          min: 0,
          max: 100
        },
        tooltip: {
          x: { show: false },
          y: {
            title: {
              formatter () {
                return ''
              }
            },
            formatter (val, opt) {
              if (opt.w.globals.labels[opt.dataPointIndex] === '') {
                return 'Autre'
              } else {
                return opt.w.globals.labels[opt.dataPointIndex]
              }
            }
          }
        }
      }
    }
  },
  watch: {
    sondage_data_resultats () {
      this.createComponentFunction()
    },
    languageQuestionAdmin: function (val) {
      if (val) {
        this.createComponentFunction()
      }
    }
  },
  computed: {
    languageQuestionAdmin () {
      return this.$store.getters.languageQuestionAdmin
    },
    series: function () {
      return [
        {
          data: this.donnees.donneesPourcentage.resultats
        }
      ]
    },

    widthSvg: function () {
      return parseInt(
        document.querySelector('.apexcharts-svg').attributes.width.value
      )
    },
    heightOfTitle: function () {
      return (
        this.titleIntoArray(
          this.donnees.intitule,
          Math.round(window.innerWidth * 1)
        ).length * 20
      )
    },
    ...mapGetters([
      'sondage_vue_resultats',
      'sondage_data_resultats',
      'languageQuestionAdmin'
    ])
  },
  mounted () {
    this.createComponentFunction()
  },
  methods: {
    sendMessageToParent (taskToDo) {
      let message = {
        task: taskToDo
      }
      window.top.postMessage(message, '*')
    },
    showModalAutre () {
      this.sendMessageToParent('scrollToTop')
      this.showAutres = !this.showAutres
    },
    testArrayContainsResults () {
      let resultsTotal = 0
      this.donnees.donneesPourcentage.resultats.forEach(result => {
        resultsTotal += result
      })
      if (resultsTotal === 0) return true
      else return false
    },
    calculMoyenne (donnees) {
      var moyenne = 0
      var sommes = 0
      // initialisation du tableau
      let array = [1, 2, 3, 4, 5]
      for (let index = 0; index < array.length; index++) {
        moyenne += array[index] * donnees.resultats[index]
        sommes += donnees.resultats[index]
      }
      if (sommes !== 0) {
        return moyenne / sommes
      } else {
        return sommes
      }
    },
    titleIntoArray (text, width) {
      let arrayGlobal = []
      let arrayFinal = ['']
      let array = text.split(' ')
      const ratio = 3
      let tailleParLigne = Math.ceil(width / ratio)
      array.forEach(element1 => {
        arrayGlobal.push([element1, element1.length])
      })
      let i = 0
      let nbLigne = 0
      arrayGlobal.forEach((element, index) => {
        if ((i += arrayGlobal[index][1] + 1) < tailleParLigne) {
          i += arrayGlobal[index][1] + 1
          arrayFinal[nbLigne] += element[0] + ' '
        } else {
          nbLigne += 1
          i = 0
          arrayFinal[nbLigne] = '' + element[0] + ' '
        }
      })
      return arrayFinal
    },
    createComponentFunction () {
      this.arrayPercentsStars = [
        this.donnees.donneesPourcentage.resultats[0] + '% - ' + 1,
        this.donnees.donneesPourcentage.resultats[1] + '% - ' + 2,
        this.donnees.donneesPourcentage.resultats[2] + '% - ' + 3,
        this.donnees.donneesPourcentage.resultats[3] + '% - ' + 4,
        this.donnees.donneesPourcentage.resultats[4] + '% - ' + 5
      ]
      this.translationEntitledAnswer = []
      switch (this.$store.getters.languageQuestionAdmin) {
        case 'fr':
          this.donnees.donneesPourcentage.noms.forEach((answer, index) => {
            if (answer === null || answer === '') {
              this.translationEntitledAnswer[index] =
                this.donnees.donneesPourcentage.resultats[index] + '% - Autre'
            } else {
              this.translationEntitledAnswer[index] =
                this.donnees.donneesPourcentage.resultats[index] +
                '% - ' +
                this.donnees.donneesPourcentage.noms[index]
            }
          })
          break
        case 'en':
          if (this.donnees.element_type !== 'notation') {
            this.donnees.donneesPourcentage.noms_en.forEach((answer, index) => {
              if (answer === null || answer === '') {
                this.translationEntitledAnswer[index] =
                  this.donnees.donneesPourcentage.resultats[index] + '% - Other'
              } else {
                this.translationEntitledAnswer[index] =
                  this.donnees.donneesPourcentage.resultats[index] +
                  '% - ' +
                  this.donnees.donneesPourcentage.noms_en[index]
              }
            })
          } else {
            this.translationEntitledAnswer = this.arrayPercentsStars
          }
          break
        case 'es':
          if (this.donnees.element_type !== 'notation') {
            this.donnees.donneesPourcentage.noms_es.forEach((answer, index) => {
              if (answer === null || answer === '') {
                this.translationEntitledAnswer[index] =
                  this.donnees.donneesPourcentage.resultats[index] + '% - Otra'
              } else {
                this.translationEntitledAnswer[index] =
                  this.donnees.donneesPourcentage.resultats[index] +
                  '% - ' +
                  this.donnees.donneesPourcentage.noms_es[index]
              }
            })
          } else {
            this.translationEntitledAnswer = this.arrayPercentsStars
          }
          break
        case 'de':
          if (this.donnees.element_type !== 'notation') {
            this.donnees.donneesPourcentage.noms_de.forEach((answer, index) => {
              if (answer === null || answer === '') {
                this.translationEntitledAnswer[index] =
                  this.donnees.donneesPourcentage.resultats[index] + '% - Other'
              } else {
                this.translationEntitledAnswer[index] =
                  this.donnees.donneesPourcentage.resultats[index] +
                  '% - ' +
                  this.donnees.donneesPourcentage.noms_de[index]
              }
            })
          } else {
            this.translationEntitledAnswer = this.arrayPercentsStars
          }
          break
      }
      // translate the entitled element (question)
      let translationEntitledQuestion = ''
      switch (this.$store.getters.languageQuestionAdmin) {
        case 'fr':
          translationEntitledQuestion = this.donnees.intitule
          break
        case 'en':
          translationEntitledQuestion = this.donnees.intitule_en
          break
        case 'es':
          translationEntitledQuestion = this.donnees.intitule_es
          break
        case 'de':
          translationEntitledQuestion = this.donnees.intitule_de
          break
      }
      if (this.sondage_vue_resultats === 'slider') {
        this.$store.commit('UNSET_CHARTS_REFS')
        this.$store.commit('SET_BAR_CHARTS_REFS', this.$refs.barchart)
      } else if (this.sondage_vue_resultats === 'all') {
        this.$store.commit('SET_BAR_CHARTS_REFS', this.$refs.barchart)
      }
      this.$refs.barchart.updateOptions({
        title: {
          text: this.titleIntoArray(
            translationEntitledQuestion,
            Math.round(window.innerWidth * 0.8)
          ),
          align: 'left',
          style: {
            fontSize: '12',
            fontWeight: '600',
            fontFamily: undefined,
            color: '#263238'
          }
        }
      })
      // translate entitled answer
      this.chartOptions = {
        background: ['#949aa8'],
        colors: ['#686b7e'],
        plotOptions: {
          bar: {
            barHeight: '90%',
            horizontal: true,
            dataLabels: {
              position: 'bottom'
            },
            colors: {
              // un jour ça serait bien de faire une boucle dessus et tester en fonction du nb de réponse
              backgroundBarColors: [
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8',
                '#949aa8'
              ]
            }
          }
        },
        xaxis: {
          categories: this.translationEntitledAnswer,
          labels: {
            formatter (val) {
              return val + '%'
            }
          }
        }
      }
    }
  }
}
</script>
<style scoped>
.button {
  border-radius: 0px;
  font-size: 12px;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/resultats/charts/BarChart.vue